import React from 'react';

function Button(props) {
	return props.loading ? (
		<button type="button" className="btn btn-primary" disabled="true">
			<span>
				<div className="spinner-border spinner-border-sm text-light" role="status">
					<span className="sr-only">Loading...</span>
				</div>
				&nbsp; {props.text}
			</span>
		</button>
	) : (
		<button type="button" className="btn btn-primary" onClick={props.onClick}>
			{props.text}
		</button>
	);
}

export default Button;